import { SyntheticEvent } from 'react';
import mcpImg from '../../assets/mcp.png';

/**
 * onError handler for MCP integration-card logos. A CDN logo that fails to
 * load (several mcp-logos/*.png were never uploaded to the DO Space) falls
 * back to the same-named copy shipped in `public/mcp-logos/` (served as a
 * plain static file — zero bundle-size cost, fetched only on failure), then
 * to the generic MCP mark. `data-fallback` staging guards against a swap
 * loop when a replacement itself errors. The CDN stays the source of truth
 * once its files exist — this never fires for a logo that loads.
 */
export const swapToBundledMcpLogo = (e: SyntheticEvent<HTMLImageElement>) => {
  const img = e.currentTarget;
  const stage = img.dataset.fallback ?? '';
  if (stage === 'final') return;

  const basename = img.src.split('/').pop()?.split('?')[0] ?? '';
  if (stage === '' && basename.endsWith('.png')) {
    img.dataset.fallback = 'local';
    img.src = `${process.env.PUBLIC_URL}/mcp-logos/${basename}`;
    return;
  }

  img.dataset.fallback = 'final';
  img.src = mcpImg;
};
